import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { utilityActions } from "../../_actions";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import VehicleDetailHeaderSummaryDisplay from "./VehicleDetailHeaderSummaryDisplay";
import { DatePicker } from "@mui/lab";
import dayjs from "dayjs";

export default function VehicleDetailDebtorInformation(props) {
  const vehicle = props.item;
  const dispatch = useDispatch();
  const states = useSelector((state) => state.utility.us_states);
  const isAdmin = useSelector((state) =>
    state.authentication.webUser.roleid === 2 ? true : false
  );

  useEffect(() => {
    if (states.items.length === 0) {
      dispatch(
        utilityActions.getUtility("us_states", {
          perPage: 1000,
          orders: [
            {
              field: "stateabbreviation",
              direction: "asc",
            },
          ],
        })
      );
    }
  }, []);

  return (
    <>
      <VehicleDetailHeaderSummaryDisplay
        vehicle={{
          vin: props?.item?.vehiclevin,
          year: props?.item?.yr,
          make: props?.item?.make,
          model: props?.item?.model,
        }}
        titleStatus={props?.item?.title_status?.statusname}
        timeInLatestStatus={props?.item?.time_in_latest_status}
        latestNote={props?.item?.latest_note?.note}
      />
      <TextField
        margin="dense"
        name={"debtorname"}
        label={"Name"}
        type="text"
        disabled={!isAdmin}
        value={vehicle.debtorname || ""}
        onChange={props.onUpdateLocal}
        fullWidth
      />
      <TextField
        margin="dense"
        name={"debtoraddress"}
        label={"Street Address"}
        type="text"
        disabled={!isAdmin}
        value={vehicle.debtoraddress || ""}
        onChange={props.onUpdateLocal}
        fullWidth
      />
      <TextField
        margin="dense"
        name={"debtorcity"}
        label={"City"}
        type="text"
        disabled={!isAdmin}
        value={vehicle.debtorcity || ""}
        onChange={props.onUpdateLocal}
        fullWidth
      />
      <FormControl fullWidth>
        <InputLabel shrink>State</InputLabel>
        <Select
          native
          name="debtorstate"
          value={vehicle.debtorstate || ""}
          onChange={props.onUpdateLocal}
          style={{ fontSize: 12 }}
          displayEmpty
          disabled={!isAdmin}
        >
          <option value="">State</option>
          {states &&
            states.items.map((state, index) => (
              <option key={index} value={state.stateid}>
                {state.stateabbreviation} - {state.statefull}
              </option>
            ))}
        </Select>
      </FormControl>
      <TextField
        margin="dense"
        name={"debtorzip"}
        label={"Zip"}
        type="text"
        disabled={!isAdmin}
        value={vehicle.debtorzip || ""}
        onChange={props.onUpdateLocal}
        fullWidth
      />
      <FormControl fullWidth>
        <InputLabel shrink>New or Used</InputLabel>
        <Select
          native
          value={vehicle.neworusedid || 0}
          onChange={props.onUpdateLocal}
          displayEmpty
          disabled={!isAdmin}
          name="neworusedid"
        >
          <option value="">Select New or Used</option>
          <option value={0}>Select New or Used</option>
          <option value={1}>New</option>
          <option value={2}>Used</option>
        </Select>
      </FormControl>
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="repossessiondate"
        label="Repo/Sale Date"
        format="MM/DD/YYYY"
        value={vehicle.repossessiondate ? dayjs(vehicle.repossessiondate) : null}
        onChange={(date) =>
          props.onUpdateLocalExplicit("repossessiondate", date ? date.format("YYYY-MM-DD") : null)
        }
      />
      <DatePicker
        slotProps={{ field: { clearable: true } }}
        margin="normal"
        disabled={!isAdmin}
        name="dateoflien"
        label="Date of Lien"
        format="MM/DD/YYYY"
        value={vehicle.dateoflien ? dayjs(vehicle.dateoflien) : null}
        onChange={(date) =>
          props.onUpdateLocalExplicit("dateoflien", date ? date.format("YYYY-MM-DD") : null)
        }
      />
    </>
  );
}
